import { ExecutiveProductReviewNameFields } from "globalConstants";

export const getMappedProductReviewData = data => {
	const { website, comment } = ExecutiveProductReviewNameFields;
	return {
		[website]: data?.website,
		[comment]: data?.comments,
	};
};
